import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const FolderBusinessEntityStateForm_ActionPermission_Fragment = graphql(`
  fragment FolderBusinessEntityStateForm_ActionPermission_Fragment on ActionAccess {
    actionId
    status
    details {
      kind
      fr
    }
  }
`);

export type FolderBusinessEntityStateForm_ActionPermission = ResultOf<
  typeof FolderBusinessEntityStateForm_ActionPermission_Fragment
>;
